<template>
  <div
    class="biz-selector-content border-primary-6"
    :class="{'disabled':disabled}"
  >
    <yxt-scrollbar wrap-class="udp-select-outer__scroll">
      <div class="biz-selector-content-taglist">
        <template v-if="value.length>0">
          <yxt-tag
            v-for="tag in value"
            :key="tag[labelKey]"
            class="mb6 mr4"
            type="info"
            :size="size"
            closable
            @close="deleteTag(tag)"
          >
            {{ tag[labelKey] }}
            <template v-if="tag.includeAll">
              {{ $t('pc_gwnl_selectOuter_group_lbl_includeAll') }}
            </template>
          </yxt-tag>
        </template>
        <template v-else-if="defaultTag">
          <yxt-tag
            type="info"
            :size="size"
            closable
            @close="deleteTag(tag)"
          >
            {{ defaultTag }}
          </yxt-tag>
        </template>
        <template v-else>
          <div class="color-gray-6 standard-size-14 mt1">
            {{ placeholder }}
          </div>
        </template>
      </div>
    </yxt-scrollbar>
    <yxt-svg
      class="biz-selector-content__icon color-gray-6 hover-primary-6"
      width="28px"
      height="28px"
      icon-class="three-dot"
    />
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    singleCloseable: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    },
    defaultTag: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    deleteTag(v) {
      let data = [...this.value];
      this.$emit('change', data.filter(item => {
        return item.id !== v.id;
      }));
    }
  }
};
</script>
